import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';

export default function PageHero({ title, subtitle, image, crumbs = [] }) {
  return (
    <section className="relative overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{ backgroundImage: `url(${image})` }}
      />
      <div className="absolute inset-0 bg-gradient-to-r from-[#0b2545]/95 via-[#0b2545]/80 to-[#0b2545]/50" />
      <div className="relative max-w-7xl mx-auto px-4 py-24 md:py-32">
        <div className="max-w-2xl">
          <nav className="flex items-center gap-2 text-xs text-amber-300 uppercase tracking-widest mb-4">
            <Link to="/" className="hover:text-white">Home</Link>
            {crumbs.map((c, i) => (
              <React.Fragment key={i}>
                <ChevronRight className="h-3 w-3" />
                <span className="text-white/80">{c}</span>
              </React.Fragment>
            ))}
          </nav>
          <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight">
            {title}
          </h1>
          {subtitle && (
            <p className="mt-5 text-lg text-slate-200 leading-relaxed max-w-xl">{subtitle}</p>
          )}
          <div className="mt-6 h-1 w-24 bg-amber-400" />
        </div>
      </div>
    </section>
  );
}
